// @flow
import React, { PureComponent } from 'react';
import AbsenteeBidModalLoader from './AbsenteeBid/AbsenteeBidModalLoader';
import AddCreditCardModalLoader from './AddCreditCard/AddCreditCardModalLoader';
import AddSearchAlertModalLoader from './AddSearchAlert/AddSearchAlertModalLoader';
import AutoPopModalContainer from '../Modals/AutoPop/AutoPopModalContainer';
import BidLimitExceededModalLoader from './BidLimitExceeded/BidLimitExceededModalLoader';
import BuyNowModalLoader from './BuyNow/BuyNowModalLoader';
import CatalogAnnouncmentModalLoader from './CatalogAnnouncement/CatalogAnnouncementModalLoader';
import ChangePasswordModalLoader from './ChangePassword/ChangePasswordModalLoader';
import CompleteAccountModalLoader from './CompleteAccount/CompleteAccountModalLoader';
import ConfirmConsignmentModalLoader from './ConfirmConsignment/ConfirmConsignmentModalLoader';
import ConfirmPasswordModalLoader from './ConfirmPassword/ConfirmPasswordModalLoader';
import { connect } from 'react-redux';
import DownloadMobileModalLoader from './DownloadMobile/DownloadMobileModalLoader';
import FeedbackModalLoader from './Feedback/FeedbackModalLoader';
import FollowSearchModalLoader from './FollowSearch/FollowSearchModalLoader';
import ForgotPasswordModalLoader from './ForgotPassword/ForgotPasswordModalLoader';
import { getOpenModal } from '../../redux/modules/modal';
import HealthcheckModalLoader from './Healthcheck/HealthcheckModalLoader';
import LoginModalLoader from './Login/LoginModalLoader';
import PreferencesModalLoader from './Preferences/PreferencesModalLoader';
import RatingsAndReviewsModalLoader from './RatingsAndReviews/RatingsAndReviewsModalLoader';
import RegisterForAuctionModalLoader from './RegisterForAuction/RegisterForAuctionModalLoader';
import ReportReviewModalLoader from './ReportReview/ReportReviewModalLoader';
import RetractBidModalLoader from './RetractBid/RetractBidModalLoader';
import SendSellerConsignmentMessageModalLoader from './SendSellerConsignmentMessage/SendSellerConsignmentMessageModalLoader';
import SendSellerMessageModalLoader from './SendSellerMessage/SendSellerMessageModalLoader';
import SetPasswordModalLoader from './SetPassword/SetPasswordModalLoader';
import ShippingAndPaymentModalLoader from './ShippingAndPayment/ShippingAndPaymentModalLoader';
import SignUpModalContainer from './SignUp/SignUpModalContainer';
import WaitingForApprovalModalLoader from './WaitingForApproval/WaitingForApprovalModalLoader';

const mapStateToProps = state => {
    return {
        openModal: getOpenModal(state),
    };
};

type Props = {|
    openModal: string,
|};

class Modals extends PureComponent<Props> {
    render() {
        const { openModal } = this.props;

        return (
            <div>
                <AutoPopModalContainer />
                <SignUpModalContainer />
                {openModal === 'ABSENTEE_BID' && <AbsenteeBidModalLoader />}
                {openModal === 'ADD_CREDIT_CARD' && <AddCreditCardModalLoader />}
                {openModal === 'ADD_SEARCH_ALERT' && <AddSearchAlertModalLoader />}
                {openModal === 'BID_LIMIT_EXCEEDED' && <BidLimitExceededModalLoader />}
                {openModal === 'BUY_NOW' && <BuyNowModalLoader />}
                {openModal === 'CATALOG_ANNOUNCEMENT' && <CatalogAnnouncmentModalLoader />}
                {openModal === 'CHANGE_PASSWORD' && <ChangePasswordModalLoader />}
                {openModal === 'COMPLETE_ACCOUNT' && <CompleteAccountModalLoader />}
                {openModal === 'CONFIRM_CONSIGNMENT' && <ConfirmConsignmentModalLoader />}
                {openModal === 'CONFIRM_PASSWORD' && <ConfirmPasswordModalLoader />}
                {openModal === 'DOWNLOAD_MOBILE' && <DownloadMobileModalLoader />}
                {openModal === 'FEEDBACK' && <FeedbackModalLoader />}
                {openModal === 'FOLLOW_SEARCH' && <FollowSearchModalLoader />}
                {openModal === 'FORGOT_PASSWORD' && <ForgotPasswordModalLoader />}
                {openModal === 'HEALTHCHECK' && <HealthcheckModalLoader />}
                {openModal === 'LOGIN' && <LoginModalLoader />}
                {openModal === 'PREFERENCES' && <PreferencesModalLoader />}
                {openModal === 'REGISTER_FOR_AUCTION' && <RegisterForAuctionModalLoader />}
                {openModal === 'REPORT_REVIEW' && <ReportReviewModalLoader />}
                {openModal === 'RETRACT_BID' && <RetractBidModalLoader />}
                {openModal === 'REVIEWS' && <RatingsAndReviewsModalLoader />}
                {openModal === 'SEND_SELLER_CONSIGNMENT_MESSAGE' && <SendSellerConsignmentMessageModalLoader />}
                {openModal === 'SEND_SELLER_MESSAGE' && <SendSellerMessageModalLoader />}
                {openModal === 'SET_PASSWORD' && <SetPasswordModalLoader />}
                {openModal === 'SHIPPING_AND_PAYMENT' && <ShippingAndPaymentModalLoader />}
                {openModal === 'WAITING_FOR_APPROVAL' && <WaitingForApprovalModalLoader />}
            </div>
        );
    }
}

export default connect(mapStateToProps)(Modals);
